import { render, staticRenderFns } from "./SortByDropdown.vue?vue&type=template&id=66ce1e1e&"
import script from "./SortByDropdown.vue?vue&type=script&lang=ts&"
export * from "./SortByDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./SortByDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports